// @flow
import React, {useState} from 'react';
import SimpleImageCarousel from '@homeaway/react-simple-image-carousel';
import PaginationDots from '@homeaway/react-pagination-dots';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_LEFT__16, CHEVRON_RIGHT__16} from '@homeaway/svg-defs';
import {
    PHOTO_NEXT,
    PHOTO_PREVIOUS,
    triggerMediaInteractionEdapEvent
} from '../../../../utils/carouselEdapUtils';

import './ImagesCarousel.less';

type PropertyCardImagesShape = {
    uri: string
};

type Props = {
    images: PropertyCardImagesShape[],
    detailPageUrl: string,
    handleClick: Object,
    edapCollectionType: string
};

const convertImagesIntoSimpleCarouselFormat = (images) => {
    return images
        .filter((listingImage) => !!listingImage)
        .map((listingImage) => ({
            src: listingImage.uri || ''
        }));
};

const ImagesCarousel = ({
    images = [],
    detailPageUrl,
    handleClick,
    edapCollectionType
}: Props) => {
    const [imageIndex, setImageIndex] = useState(0);

    const onNextClick = (index) => {
        setImageIndex(index);
        triggerMediaInteractionEdapEvent(
            edapCollectionType,
            PHOTO_NEXT,
            images[index].uri,
            index
        );
    };

    const onPrevClick = (index) => {
        setImageIndex(index);
        triggerMediaInteractionEdapEvent(
            edapCollectionType,
            PHOTO_PREVIOUS,
            images[index].uri,
            index
        );
    };

    const navigateToListing = () => {
        if (handleClick) {
            handleClick();
        }

        window.open(detailPageUrl, '_blank');
    };

    return (
        <div className="ImagesCarousel Image__thumbnail">
            <SimpleImageCarousel
                images={convertImagesIntoSimpleCarouselFormat(images)}
                index={imageIndex}
                transitionStyle="slide"
                transitionDuration={250}
                onNextClick={onNextClick}
                onPrevClick={onPrevClick}
                onClick={navigateToListing}
                tabIndex={-1}
                renderButtons={({setPrevRef, setNextRef}) => {
                    return [
                        <button
                            key="0"
                            className="SimpleImageCarousel__button SimpleImageCarousel__button--left"
                            data-wdio="SimpleImageCarousel__button--prev"
                            ref={setPrevRef}
                            tabIndex="-1"
                        >
                            <span className="sr-only">{'Previous Image'}</span>
                            <SVGIcon
                                className="SimpleImageCarousel__svg SimpleImageCarousel__svg--left"
                                markup={CHEVRON_LEFT__16}
                            />
                        </button>,
                        <button
                            key="1"
                            className="SimpleImageCarousel__button SimpleImageCarousel__button--right"
                            data-wdio="SimpleImageCarousel__button--next"
                            ref={setNextRef}
                            tabIndex="-1"
                        >
                            <span className="sr-only">{'Next Image'}</span>
                            <SVGIcon
                                className="SimpleImageCarousel__svg SimpleImageCarousel__svg--right"
                                markup={CHEVRON_RIGHT__16}
                            />
                        </button>
                    ];
                }}
            />
            <PaginationDots imageIndex={imageIndex} maxImages={images.length} />
        </div>
    );
};

export default ImagesCarousel;
